import { render } from "./TariffDetails.vue?vue&type=template&id=1d3b1338&scoped=true"
import script from "./TariffDetails.vue?vue&type=script&lang=js"
export * from "./TariffDetails.vue?vue&type=script&lang=js"

import "./TariffDetails.vue?vue&type=style&index=0&id=1d3b1338&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3b1338"]])

export default __exports__